import { App } from 'antd';

/**
 * Brief confirmation for important actions (CLAUDE.md → Web conventions →
 * Feedback). Built on Ant's App context (<AntApp> in main.tsx), so toasts
 * follow the theme and colour mode.
 */
export function useToast() {
  const { message } = App.useApp();
  return {
    success: (content: string) => message.success(content),
    error: (content: string) => message.error(content),
    info: (content: string) => message.info(content),
  };
}
